import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { DoubleTeaserTileTemplate } from "./double-teaser-tile.templates";

export default {
    title: "Website/Partial Templates/Double Teaser Tile (H.15)",
    render: DoubleTeaserTileTemplate.bind({}),
    tags: ["autodocs"],
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
};

export const DoubleTeaserTile = {};
